import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, FormHelperText } from '@mui/material';

export const UpdateQuizModal = ({
  show,
  handleClose,
  lngsltd,
  editCourseID,
  setEditCourseID,
  courseData,
  editCourseNameError,
  editTitle,
  setEditTitle,
  editQuizTitleError,
  editDescription,
  setEditDescription,
  handleUpdate,
}) => {
  return (
    <Dialog open={show} onClose={handleClose} fullWidth>
      <DialogTitle style={{ backgroundColor: '#efedf0' }}>
        {lngsltd["Edit Quiz"]}
      </DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal" error={Boolean(editCourseNameError)} required>
          <InputLabel >
            {lngsltd["Select Course"]}
          </InputLabel>
          <Select
            id="edit-coursename"
            required
            value={editCourseID}
            onChange={(e) => setEditCourseID(e.target.value)}
            fullWidth
            label={lngsltd["Select Course"]}
          >
            <MenuItem value="" disabled>
              {lngsltd["Select Course Name"]}
            </MenuItem>
            {courseData.map((data) => (
              <MenuItem key={data.courseID} value={data.courseID}>
                {data.courseName}
              </MenuItem>
            ))}
          </Select>
          {editCourseNameError && <FormHelperText>{editCourseNameError}</FormHelperText>}
        </FormControl>

        <TextField
          margin="normal"
          fullWidth
          id="editTitle"
          label={`${lngsltd["Title"]}`}
          required
          value={editTitle}
          onChange={(e) => setEditTitle(e.target.value)}
          error={Boolean(editQuizTitleError)}
          helperText={editQuizTitleError}
        />

        <TextField
          margin="normal"
          fullWidth
          id="editDescription"
          label={lngsltd["Description"]}
          multiline
          rows={3}
          value={editDescription}
          onChange={(e) => setEditDescription(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleUpdate}>
          {lngsltd["Save"]}
        </Button>
        <Button variant="outlined" color='error' onClick={handleClose}>
          {lngsltd["Cancel"]}
        </Button>
      </DialogActions>
    </Dialog>
  );
};